'use client'

import AutoWidget from '@components/common/AutoWidget/autoWidget'
import { getR2d2CommonProperties } from '@utils/r2d2Payload'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState, Suspense } from 'react'
import { AutoProduct, type AutoWidgetVariant } from 'src/enums/AutoProduct'
import { type BannerIconPosition } from 'src/enums/NewFlowBanner'
import { getPageType } from 'src/helpers/commonHelpers'
import styles from './bikeWidget.module.scss'

interface newFlowBannerProps {
  heading?: string
  subHeading?: string
  ctaText?: string
  iconSrc?: string
  iconAlt?: string
  iconPosition: BannerIconPosition
}

type RegexPattern = string
interface BikeWidgetProps {
  widgetHeading: string
  disclaimer?: string
  inputPlaceholder?: string
  widgetCtaText?: string
  segmentEventCommonProperties?: object
  newFlowBanner: newFlowBannerProps
  isSemPage: boolean
  isBottomFloater?: boolean
  widgetVariant?: AutoWidgetVariant
  regexPatternsData?: RegexPattern[]
  isOldLayout?: boolean
}

const BikeWidgetImp = ({
  widgetHeading,
  disclaimer,
  inputPlaceholder,
  widgetCtaText,
  segmentEventCommonProperties,
  newFlowBanner,
  isSemPage,
  isBottomFloater,
  widgetVariant,
  regexPatternsData,
  isOldLayout,
}: BikeWidgetProps) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // Combine pathname and searchParams to form the full path
  const queryString = searchParams.toString()
  const fullPath = queryString ? `${pathname}?${queryString}` : pathname

  const newBikeRedirectionUrl = `/bike-journey/nsr?flow=new${
    fullPath?.split('?')[1] ? `&${fullPath?.split('?')[1]}` : ''
  }`
  const [r2d2CommonProperties, setR2d2CommonProperties] = useState({})
  useEffect(() => {
    const r2d2Props = getR2d2CommonProperties()
    setR2d2CommonProperties(r2d2Props)
  }, [])

  return (
    <div className={styles.bikeWidgetRootContainer}>
      <AutoWidget
        widgetHeading={widgetHeading}
        disclaimer={disclaimer}
        inputPlaceholder={inputPlaceholder}
        widgetCtaText={widgetCtaText || 'Get quote'}
        segmentEventCommonProperties={segmentEventCommonProperties}
        newFlowBanner={newFlowBanner}
        widgetType={getPageType(isSemPage)}
        product={AutoProduct.Bike}
        newFlowRedirectionUrl={newBikeRedirectionUrl}
        widgetVariant={widgetVariant}
        isBottomFloater={isBottomFloater}
        isSemPage={isSemPage}
        isOldLayout={isOldLayout || isSemPage}
        r2d2Commonproperties={r2d2CommonProperties}
        regexPatternsData={regexPatternsData}
      />
    </div>
  )
}

const BikeWidget = props => (
  <Suspense>
    <BikeWidgetImp {...props} />
  </Suspense>
)
export default BikeWidget
